export default "<div class=\"spinner\">\n    <div class=\"sk-rotating-plane\"></div>\n</div>"